import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Card, Tabs, DataTable, StatusBadge} from "../UI";
import {tokens} from "../../theme/tokens";

// Corporate approval is the source of truth for admin vetting. pending renders
// neutral, approved success, rejected danger (per spec — StatusBadge's default
// map treats pending as a warn tone, so approval tone is set explicitly).
export const approvalTone = (s) =>
    s === "approved" ? "success" : s === "rejected" ? "danger" : "neutral";

const BusinessList = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [list, setList] = useState([]);
    const [tab, setTab] = useState("pending");

    const columns = [
        {
            name: 'Name',
            sortable: true,
            grow: 2,
            cell: row => <div><Link to={"/business/" + row.id}>{row.name}</Link></div>,
        },
        {
            name: 'Contact',
            grow: 2,
            cell: row => (
                <div>
                    <div>{row.contact_email}</div>
                    <div style={{color: tokens.colors.muted, fontSize: tokens.typography.size.xs}}>{row.contact_phone}</div>
                </div>
            ),
        },
        {
            name: 'Approval',
            cell: row => <StatusBadge tone={approvalTone(row.approval_status)}>{row.approval_status || 'pending'}</StatusBadge>,
        },
        {
            name: 'Active',
            cell: row => row.admin_active === 1
                ? <StatusBadge tone="success">Active</StatusBadge>
                : <StatusBadge tone="neutral">Inactive</StatusBadge>,
        },
        {
            name: 'Departments',
            selector: 'no_of_departments',
            sortable: true,
            right: true,
        },
        {
            name: 'Accounts',
            selector: 'no_of_accounts',
            sortable: true,
            right: true,
        },
        {
            name: 'This month',
            sortable: true,
            right: true,
            selector: row => row.this_month || 0,
            cell: row => `KES ${row.this_month_string || (row.this_month || 0)}`,
        },
        {
            name: 'Wallet',
            sortable: true,
            right: true,
            selector: row => row.wallet_cents || 0,
            cell: row => `KES ${((row.wallet_cents || 0) / 100).toFixed(2)}`,
        },
    ];

    const load = (approvalStatus) => {
        let data = new FormData();
        if (approvalStatus) data.append("approval_status", approvalStatus);
        setIsLoading(true);
        postData(Endpoints.BUSINESS_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                setList((res && res.data) || []);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        updateDocumentTitle("Businesses")
        load(tab === "all" ? "" : tab);
    }, [tab]);

    return (
        <PageLayout title="Businesses">
            <Tabs
                tabs={[
                    {key: "pending", label: "Pending"},
                    {key: "approved", label: "Approved"},
                    {key: "rejected", label: "Rejected"},
                    {key: "all", label: "All"},
                ]}
                value={tab}
                onChange={setTab}
            />

            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={list}
                    progressPending={isLoading}
                    pointerOnHover={true}
                    noHeader={true}
                    onRowClicked={e => {
                        history.push('/business/' + e.id);
                    }}
                />
            </Card>
        </PageLayout>
    )
};

export default BusinessList;
